<template>
  <div class="col-xl-12">
    <div class="card" v-if="!event_mapping">{{ t("loading") }}</div>
    <div class="card" v-if="event_mapping">
      <div class="card-header card-no-border">
        <div class="header-top">
          <h5 class="m-0">{{ t("joinedEvents") }}</h5>
        </div>
      </div>

      <div class="event-tabs-wrap">
        <ul class="nav event-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              type="button"
              class="nav-link event-tab-btn"
              :class="{ active: this.event_load_type === 'MYEVENT' }"
              @click="events('MYEVENT')"
            >
              {{ t("myEvents") }}
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              type="button"
              class="nav-link event-tab-btn"
              :class="{ active: this.event_load_type === 'OPEN' }"
              @click="events('OPEN')"
            >
              {{ t("openEvents") }}
            </button>
          </li>
          <li
            v-if="
              this.user.role_name === 'system' ||
              this.user.role_name === 'systemadmin'
            "
            class="nav-item"
            role="presentation"
          >
            <button
              type="button"
              class="nav-link event-tab-btn"
              :class="{ active: this.event_load_type === 'ALL' }"
              @click="events('ALL')"
            >
              {{ t("allEvents") }}
            </button>
          </li>
        </ul>
      </div>

      <div class="card-body pt-0 campaign-table">
        <p>&nbsp;</p>
        <div class="d-flex justify-content-left" v-if="this.is_event_type_open === 'Y'" >
          <p style="font-size:10px; color: gray;">
             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ t("openEventNotice") }}
            <!-- <br>
            <i class="fa fa-info-circle"></i>&nbsp;กิจกรรม open: ถ้ามีการแจกภาพ หรือจำหน่ายภาพผ่านช่องทางอื่นๆ ขอความร่วมมือ ทำหลังจากเปิดขายรูปผ่านระบบเกิน 24 ชม. -->
          </p>
          
          <p>&nbsp;</p>
          
        </div>
        
        <!-- event open -->
        <div
          class="table-responsive currency-table"
          v-if="this.is_event_type_open === 'Y'"
        >
          <table class="table">
            <thead>
              <tr>
                <th>{{ t("event") }}</th>
                <th style="text-align: center">{{ t("registerToShoot") }}</th>
                <th style="text-align: center">{{ t("photographerCount") }}</th>
              </tr>
            </thead>
            <tbody v-if="this.is_loading === 'N' && event_mapping.length === 0">
              <tr>
                <td colspan="6">
                  <div class="d-flex justify-content-center">{{ t("noData") }}</div>
                </td>
              </tr>
            </tbody>
            <tbody v-if="this.is_loading === 'Y' && event_mapping.length === 0">
              <tr>
                <td colspan="6">
                  <div class="d-flex justify-content-center">
                    <img
                      style="align-items: center; width: 60px"
                      src="../../assets/images/running_loading.svg"
                    />
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody v-if="event_mapping.length !== 0">
              <tr v-for="event in event_mapping" :key="event">
                <td>
                  {{ event.title }}&nbsp;
                  [<vue-feather type="user-check"></vue-feather>Open] <p style=" font-size: 9px;">{{ t("dateLabel") }} {{ event.event_date_text }}&nbsp; {{ t("atLabel") }} {{ event.province }}</p>
                </td>

                <td style="text-align: center">
                  <button
                    v-if="
                      event.user_register_count < event.number_of_photographer
                    "
                    @click="events_register(event.event_key)"
                      class="btn btn-primary event-action-btn event-pill-btn event-pill-btn-primary"
                  >
                    {{ t("register") }}
                  </button>
                  <button
                    v-if="
                      event.user_register_count >= event.number_of_photographer
                    "
                    disabled
                      class="btn btn-light event-action-btn event-pill-btn event-pill-btn-muted"
                  >
                    {{ t("full") }}
                  </button>
                </td>
                  <td style="text-align: center">
                    ({{ event.user_register_count }}/{{ event.number_of_photographer }})
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          class="table-responsive currency-table"
          v-if="this.is_event_type_open !== 'Y'"
        >
          <table class="table">
            <thead>
              <tr>
                <th>{{ t("registeredEvents") }}</th>
                <th style="text-align: center">{{ t("order") }}</th>
                <th style="text-align: center">{{ t("upload") }}</th>
                <th style="text-align: center">{{ t("uploadVideo") }}</th>
                <th style="text-align: center">{{ t("shareDrive") }}</th>
                <th style="text-align: center">{{ t("unregister") }}</th>
              </tr>
            </thead>
            <tbody v-if="this.is_loading === 'N' && event_mapping.length === 0">
              <tr>
                <td colspan="6">
                  <div class="d-flex justify-content-center">{{ t("noData") }}</div>
                </td>
              </tr>
            </tbody>
            <tbody v-if="this.is_loading === 'Y' && event_mapping.length === 0">
              <tr>
                <td colspan="5">
                  <div class="d-flex justify-content-center">
                    <img
                      style="align-items: center; width: 60px"
                      src="../../assets/images/running_loading.svg"
                    />
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody v-if="event_mapping.length !== 0">
              <tr v-for="event in event_mapping" :key="event">
                <td v-if="event.is_lock_user !== 'N'">
                  {{ event.title }}
                  <p style=" font-size: 9px;">{{ t("dateLabel") }} {{ event.event_date_text }} <span v-if="event.is_hybrid ==='Y' && event.is_mhao_hybrid === 'N'">[Hybrid]</span></p>
                </td>
                <td v-if="event.is_lock_user === 'N'">
                  {{ event.title }}&nbsp;
                  [<vue-feather type="user-check"></vue-feather>Open]
                  <p style=" font-size: 9px;">{{ t("dateLabel") }} {{ event.event_date_text }} <span v-if="event.is_hybrid ==='Y' && event.is_mhao_hybrid === 'N'">[Hybrid]</span></p>
                </td>

                
                <td style="text-align: center">
                  <router-link
                    v-if="event.is_mhao === 'Y' || event.is_free_download_keep_contract ==='Y' || event.is_mhao_hybrid ==='Y'"
                    :to="'/orders/' + event.event_key"
                    class="btn btn-primary event-action-btn event-pill-btn event-pill-btn-primary"
                    ><vue-feather type="shopping-bag" class="event-btn-icon"></vue-feather>ORDER</router-link
                  >
                  <router-link
                    v-if="event.is_mhao !== 'Y' && event.is_free_download_keep_contract !=='Y' && event.is_mhao_hybrid !=='Y'"
                    :to="'/order/' + event.event_key"
                    class="btn btn-primary event-action-btn event-pill-btn event-pill-btn-primary"
                    ><vue-feather type="shopping-bag" class="event-btn-icon"></vue-feather>ORDER</router-link
                  >
                </td>
                <td style="text-align: center">
                  <router-link
                    v-if="event.uploadable === 'Y'"
                    :to="'/upload/' + event.event_key"
                    class="btn btn-primary event-action-btn event-pill-btn event-pill-btn-primary"
                    ><vue-feather type="image" class="event-btn-icon"></vue-feather>PHOTOS</router-link
                  >
                  <router-link
                    v-if="event.uploadable === 'N'"
                    :to="'/upload/' + event.event_key"
                    class="btn btn-light event-action-btn event-pill-btn event-pill-btn-muted"
                    ><vue-feather type="image" class="event-btn-icon"></vue-feather>{{ t("disable") }}</router-link
                  >
                </td>

                <td style="text-align: center" v-if="event.is_enable_vdo === 'Y'">
                  <router-link
                    v-if="event.uploadable === 'Y'"
                    :to="'/upload-vdo/' + event.event_key"
                    class="btn btn-primary event-action-btn event-pill-btn event-pill-btn-primary"
                    ><vue-feather type="video" class="event-btn-icon"></vue-feather>VIDEOS</router-link
                  >
                  <router-link
                    v-if="event.uploadable === 'N'"
                    :to="'/upload-vdo/' + event.event_key"
                    class="btn btn-light event-action-btn event-pill-btn event-pill-btn-muted"
                    ><vue-feather type="video" class="event-btn-icon"></vue-feather> {{ t("disable") }}</router-link
                  >
                </td>
                <td style="text-align: center" v-if="event.is_enable_vdo === 'N'">
                  <p style="font-size: 9px;">-</p>
                </td>
                
                <td style="text-align: center">
                  <div
                    v-if="
                      event.google_drive === null || event.google_drive === ''
                    "
                  >
                    <button
                      type="button"
                      disabled
                      class="btn btn-light event-action-btn event-pill-btn event-pill-btn-muted"
                    >
                      {{ t("waitingData") }}
                    </button>
                  </div>
                  <div v-else>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      :href="event.google_drive"
                      class="btn btn-primary event-action-btn event-pill-btn event-pill-btn-primary"
                    >
                      <vue-feather type="link" class="event-btn-icon"></vue-feather>
                      {{ t("shareDrive") }}
                    </a>
                  </div>
                </td>
                <td style="text-align: center">
                  <button
                    disabled
                    v-if="event.uploadable === 'N'"
                    class="btn btn-danger event-action-btn event-pill-btn event-pill-btn-danger"
                  >
                    {{ t("cancel") }}
                  </button>
                  <button
                    v-if="event.uploadable === 'Y'"
                    @click="events_unregister(event.event_key)"
                    class="btn btn-danger event-action-btn event-pill-btn event-pill-btn-danger"
                  >
                    {{ t("cancel") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.btn:disabled {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: #fff !important;
  opacity: 0.65;
  cursor: not-allowed !important;
}

.btn {
  min-width: 120px;
  padding: 0.37rem 0.7rem !important;
  font-size: 0.9rem;
  letter-spacing: 0.02em;
}

.btn:focus {
  box-shadow: 0 0 0 0.2rem color-mix(in srgb, var(--theme-deafult) 22%, transparent);
}

.event-action-btn {
  letter-spacing: 0.01em;
  white-space: nowrap;
}

.event-pill-btn {
  border-radius: 10px;
  font-weight: 700;
  box-shadow: 0 8px 18px color-mix(in srgb, var(--theme-deafult) 22%, transparent);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.24rem;
}

.event-pill-btn-primary {
  background: var(--theme-deafult);
  border-color: var(--theme-deafult);
  color: #ffffff;
}

.event-pill-btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  background: color-mix(in srgb, var(--theme-deafult) 88%, black);
  border-color: color-mix(in srgb, var(--theme-deafult) 88%, black);
  box-shadow: 0 10px 20px color-mix(in srgb, var(--theme-deafult) 34%, transparent);
}

.event-pill-btn-muted {
  background: #f3f7fc;
  border-color: #d7e1ef;
  color: #5d6c82;
  box-shadow: none;
}

.event-pill-btn-danger {
  background: var(--theme-deafult);
  border-color: var(--theme-deafult);
  color: #ffffff;
}

.event-pill-btn-danger:hover:not(:disabled) {
  background: color-mix(in srgb, var(--theme-deafult) 88%, black);
  border-color: color-mix(in srgb, var(--theme-deafult) 88%, black);
  box-shadow: 0 10px 20px color-mix(in srgb, var(--theme-deafult) 34%, transparent);
}

.event-btn-icon {
  width: 13px;
  height: 13px;
}
.table-fit {
  width: 1px;
}

.event-tabs-wrap {
  display: flex;
  justify-content: center;
  margin-top: 0.25rem;
}

.event-tabs {
  display: inline-flex;
  gap: 0.5rem;
  padding: 0.4rem;
  border-radius: 999px;
  background: #f4f7fb;
  border: 1px solid #e3ebf5;
}

.event-tabs .nav-link,
.event-tab-btn {
  border: none;
  border-radius: 999px;
  padding: 0.42rem 1rem;
  color: #4a5f80;
  font-weight: 600;
  background: transparent;
  transition: all 0.2s ease;
}

.event-tabs .nav-link:hover,
.event-tab-btn:hover {
  color: #010307;
  background: color-mix(in srgb, var(--theme-deafult) 10%, white);
}

.event-tabs .nav-link.active,
.event-tab-btn.active {
  color: #ffffff;
  background: var(--theme-deafult);
  box-shadow: 0 6px 14px color-mix(in srgb, var(--theme-deafult) 35%, transparent);
}

@media (max-width: 768px) {
  .event-shell .card-header {
    padding-bottom: 0.75rem;
  }

  .event-tabs-wrap {
    justify-content: center;
    padding: 0 0.25rem;
  }

  .event-tabs {
    flex-wrap: wrap;
    justify-content: center;
  }

  .currency-table .table th,
  .currency-table .table td {
    padding: 0.35rem 0.3rem;
  }

  .currency-table td .event-action-btn {
    width: 100%;
    min-width: 0;
  }

  .event-action-btn {
    min-width: 0;
  }
}

</style>
<script>
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "@sweetalert2/theme-bootstrap-4/bootstrap-4.scss";
import { useCookies } from "vue3-cookies";
export default {
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  data() {
    return {
      event_mapping: [],
      is_loading: "N",
      loading: true,
      user: {},
      event_load_type: null,
      is_event_type_open: "N",

      token: null,
      text: {
        TH: {
          loading: "Loading...",
          joinedEvents: "กิจกรรมที่เข้าร่วม",
          myEvents: "กิจกรรมของฉัน",
          openEvents: "กิจกรรมโอเพ่น",
          allEvents: "กิจกรรมทั้งหมด",
          openEventNotice:
            "กิจกรรม open: คืองานที่ช่างภาพสามารถขออนุญาตและลงทะเบียนเข้าร่วมถ่ายได้เลย แต่ช่างภาพต้องเข้าร่วมกลุ่ม Line ก่อนวันจัดกิจกรรม เพื่อรับทราบข้อมูลกิจกรรมและข้อตกลงของการเข้าถ่ายนั้นๆ โดยอาจไม่ได้สิทธิในการเข้าถ่าย หากไม่เข้ากลุ่ม Line (บางกิจกรรม)",
          event: "กิจกรรม",
          registerToShoot: "ลงทะเบียนเข้าถ่าย",
          photographerCount: "จำนวนช่างภาพ",
          lineGroup: "ไลน์กลุ่ม",
          noData: "ไม่พบข้อมูล",
          dateLabel: "วันที่",
          atLabel: "ณ.",
          register: "ลงทะเบียน",
          full: "ช่างภาพเต็ม",
          lineAfterRegister: "-แสดงเมื่อลงทะเบียนสำเร็จ-",
          registeredEvents: "กิจกรรมที่ลงทะเบียน",
          order: "ORDER",
          upload: "PHOTOS",
          uploadVideo: "VIDEOS",
          shareDrive: "Share drive",
          unregister: "ยกเลิกลงทะเบียน",
          waitingData: "รอเพิ่มข้อมูล",
          cancel: "CANCEL",
          disable: "DISABLE",
          sessionExpired: "เซสชั่นหมดอายุ กรุณาเข้าล็อกอินเข้าสู่ระบบอีกครั้ง",
          confirmOpenRegister:
            "กิจกรรม open: คือกิจกรรมที่ช่างภาพสามารถเข้าร่วมถ่ายได้ แต่ช่างภาพต้องเข้าร่วมกลุ่ม Line ก่อนวันจัดกิจกรรม เพื่อรับทราบข้อมูลกิจกรรมและข้อตกลงของการเข้าถ่ายนั้นๆ เพื่อให้จำนวนของช่างภาพที่เข้าถ่ายเป็นไปตามที่ตกลงกับผู้จัดกิจกรรม คุณต้องการลงทะเบียนเข้าร่วมกิจกรรมหรือไม่?",
          duplicateRegister:
            "คุณได้ลงทะเบียนเข้าร่วมแล้ว กรุณาตรวจสอบที่ กิจกรรมของฉัน",
          registerSuccess:
            "ลงทะเบียนเข้าร่วมสำเร็จ กรุณาตรวจสอบที่ กิจกรรมของฉัน",
          genericError: "พบข้อผิดพลาด กรุณารีเฟรชหน้าใหม่แล้วลองอีกครั้ง",
          confirmUnregister: "คุณต้องการยกเลิกการลงทะเบียนเข้าร่วมกิจกรรมใช่หรือไม่?",
          success: "สำเร็จ",
        },
        EN: {
          loading: "Loading...",
          joinedEvents: "Joined Events",
          myEvents: "My Events",
          openEvents: "Open Events",
          allEvents: "All Events",
          openEventNotice:
            "Open events allow photographers to register and join directly. You must join the event Line group before the event date to receive details and shooting agreements. Access may be denied if you do not join the Line group (for some events).",
          event: "Event",
          registerToShoot: "Register",
          photographerCount: "Photographers",
          lineGroup: "Line Group",
          noData: "No data found",
          dateLabel: "Date",
          atLabel: "at",
          register: "Register",
          full: "Full",
          lineAfterRegister: "-Shown after successful registration-",
          registeredEvents: "Registered Events",
          order: "Order",
          upload: "Upload",
          uploadVideo: "Upload VIDEO",
          shareDrive: "Share Drive",
          unregister: "Unregister",
          waitingData: "Waiting for data",
          cancel: "Cancel",
          disable: "Disable",
          sessionExpired: "Your session has expired. Please log in again.",
          confirmOpenRegister:
            "Open events allow photographers to join shooting directly, but joining the event Line group before the event date is required to receive details and agreements. Do you want to register for this event?",
          duplicateRegister:
            "You are already registered. Please check My Events.",
          registerSuccess:
            "Registration successful. Please check My Events.",
          genericError: "An error occurred. Please refresh and try again.",
          confirmUnregister: "Do you want to cancel this registration?",
          success: "Success",
        },
      },
    };
  },
  async mounted() {
    this.token = localStorage.getItem("jwt");
    await this.events(this.event_load_type || "MYEVENT");
  },
  methods: {
    t(key) {
      const language = process.env.VUE_APP_LANGUAGE === "EN" ? "EN" : "TH";
      return (this.text[language] && this.text[language][key]) || key;
    },
    logout: async function () {
      this.cookies.remove("jwt");
      localStorage.removeItem("jwt");
      localStorage.removeItem("user");
      localStorage.removeItem("user_id");

      this.$router.replace("/auth/login");
    },
    async events(_event_load_type) {
      this.event_mapping= [];
      this.event_load_type = _event_load_type;
      if (_event_load_type === "OPEN") {
        this.is_event_type_open = "Y";
      } else {
        this.is_event_type_open = "N";
      }
      this.is_loading = "Y";
      try {
        this.user = JSON.parse(localStorage.getItem("user"));

         const headers = {
         'Authorization': 'Bearer ' + this.token
          };
        let data = {
          event_load_type: _event_load_type,
        };
        const response = await axios.post("/v1/user/event", data, {
          headers
        });
        if (response.data.status === "success") {
          this.event_mapping = response.data.body;
          //console.log("this.event_mapping"+JSON.stringify(this.event_mapping))
          this.is_loading = "N";
          this.loading = false;
        } else {
          alert(this.t("sessionExpired"));
          //this.logout();
          //location.reload();
        }
      } catch (error) {
        alert(this.t("sessionExpired"));
        //this.$router.push({ path: "/auth/login" });
      }
    },
    async events_register(_event_key) {
      //   let result = await Swal.fire({
      //   icon: "info",
      //   title:
      //     "<b style='color: red'><u>ข้อตกลงการเข้าร่วมกิจกรรมโอเพ่น</u></b>",
      //   html: "งานโอเพ่น คืองานที่ช่างภาพ สามารถเข้าร่วมถ่ายได้ แต่ช่างภาพต้องเข้าร่วมกลุ่ม Line ก่อนวันจัดกิจกรรม เพื่อรับทราบข้อมูลกิจกรรมและข้อตกลงของการเข้าถ่ายนั้นๆ <br> เพื่อให้จำนวนของช่างภาพที่เข้าถ่าย เป็นไปตามที่ตกลงกับผู้จัดกิจกรรม <br> คุณต้องการลงทะเบียนเข้าร่วมกิจกรรม ?",

      //   showCancelButton: true,
      //   confirmButtonColor: "#3085d6",
      //   cancelButtonColor: "#7991a8",
      //   confirmButtonText: "ลงทะเบียนเข้าร่วม",
      //   cancelButtonText: "ยกเลิก",
      // }).then((result) => {
      //   if (result.isConfirmed) {

      //   }else{

      //   }
      //    console.log("rs",result)

      // });

      if (confirm(this.t("confirmOpenRegister"))) {
        try {
          let data = {
            event_key: _event_key,
          };
          //console.log("data:",data)
          const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem("jwt")
          };
          const response = await axios.post("/v1/user/event-register", data, {
            headers
          });
          //console.log("response:"+JSON.stringify(response))
          if (response.data.status === "success") {
            if (response.data.message === "duplicate") {
              alert(this.t("duplicateRegister"));
              await this.events("MYEVENT");
            } else {
              alert(this.t("registerSuccess"));
              location.reload();
            }
          } else {
            alert(this.t("genericError"));
            location.reload();
          }
        } catch (error) {
          console.error("events_register: ", error);
        }
      }
    },
    async events_unregister(_event_key) {
      if (confirm(this.t("confirmUnregister"))) {
        try {
          let data = {
            event_key: _event_key,
          };
          const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem("jwt")
          };
          const response = await axios.post("/v1/user/event-unregister", data, {
            headers
          });
          if (response.data.status === "success") {
            alert(this.t("success"));
            await this.events("MYEVENT");
          } else {
            alert(this.t("genericError"));
            location.reload();
          }
        } catch (error) {
          console.error("events_register: ", error);
        }
      }
    },
  },
};
</script>
